import { Address } from "src/api/address";
import { CartShippingItxDto, PriceItxDto, ShippingMethodItxDto, ShoppingCartItxDto } from "src/api/customer";
import { DropPoint } from "src/api/locations";
import { AddressSelectorParams } from "../../BasketAddress/BasketAddressManager";
import { GroupState } from "src/model/state/partials/checkout.model";
import { renderPrice } from "src/utils/Prices";

export const EXPEDITION_SHIPPING_TYPE = {
    DROP2HOME: "DROP2HOME",
    DROPPOINT: "DROPPOINT",
    BOTH: "BOTH"
  } as any
  
export type ExpeditionShippingType = (typeof EXPEDITION_SHIPPING_TYPE)[keyof typeof EXPEDITION_SHIPPING_TYPE];

export interface FinalGroups {
    all: GroupState[],
    international: GroupState[],
    national: GroupState[]
}

export interface NewExpedition  {
    sellerdId: number;
    shippingTypeSelected: ExpeditionShippingType;
    homeAddressSelected: Address | null,
    dropPointAddressSelected: DropPoint | null,
    selectedDPShippingMethodId: number | null,
    selectedDHShippingMethodId: number | null,
    selectedDHShippingMethodPrice: PriceItxDto | null
    selectedDPShippingMethodPrice: PriceItxDto | null
}

export const createExpeditionBody = (
    shippingMethodsGroupData: ShippingMethodItxDto[],
    address: AddressSelectorParams,
    sellerdId: number,
    type: ExpeditionShippingType,
  ): NewExpedition | Object => {
  
      const defaulExpeditionObject = {
        sellerdId: sellerdId,
        shippingTypeSelected: null,
        homeAddressSelected: null,
        dropPointAddressSelected: null,
        selectedDPShippingMethodId: null,
        selectedDHShippingMethodId: null
      }
  
     let newExpedition = {}
  
     const foundDHShippingMethod = getShippingMethodForType(EXPEDITION_SHIPPING_TYPE.DROP2HOME, shippingMethodsGroupData) ?? null ;
     const foundDPShippingMethod = getShippingMethodForType(EXPEDITION_SHIPPING_TYPE.DROPPOINT, shippingMethodsGroupData) ?? null ;
     
     if (foundDHShippingMethod && type.includes(EXPEDITION_SHIPPING_TYPE.DROP2HOME)){
         newExpedition = {
             ...defaulExpeditionObject,
             shippingTypeSelected:EXPEDITION_SHIPPING_TYPE.DROP2HOME,
             homeAddressSelected: address?.home ?? "",
            
             
            }
    } else if(foundDPShippingMethod) {
        newExpedition = {
            ...defaulExpeditionObject,
            shippingTypeSelected: EXPEDITION_SHIPPING_TYPE.DROPPOINT,
            dropPointAddressSelected: address?.droppoint ?? "",
            
        }
    }

    newExpedition = {...newExpedition, 
        selectedDHShippingMethodId: foundDHShippingMethod?.idShippingMethod ?? null,
        selectedDPShippingMethodId: foundDPShippingMethod?.idShippingMethod ?? null,
        selectedDHShippingMethodPrice: foundDHShippingMethod?.price ?? null,
        selectedDPShippingMethodPrice: foundDPShippingMethod?.price ?? null
    }
     
      return newExpedition
  };
  

const updateExpeditionAddress = ( 
    expedition: NewExpedition,
    address: AddressSelectorParams,
    type: ExpeditionShippingType
): NewExpedition => {

    let currentExpedition = {...expedition}

    if (type === EXPEDITION_SHIPPING_TYPE.DROP2HOME){
        currentExpedition = {
            ...currentExpedition, 
            shippingTypeSelected: type,
            homeAddressSelected: address?.home,
            
           }
       } else {
        currentExpedition = {
           ...currentExpedition,
           shippingTypeSelected: type,
           dropPointAddressSelected: address.droppoint,
           
          }
     }

     return currentExpedition
};

export const updateExpeditionsAddress = (
    expeditions: Record<string, NewExpedition>,
    address: AddressSelectorParams,
    expeditionsIdForChangeAddress: number[],
    type: ExpeditionShippingType
) => {
    let updatedExpeditions = {...expeditions}
    let newUpdateExpeditions = {}
      expeditionsIdForChangeAddress.forEach((currentId) => {
        const updateExpedition = {[`${currentId}`]: updateExpeditionAddress(expeditions[currentId], address, type)};
        newUpdateExpeditions = {...newUpdateExpeditions, ...updateExpedition}
    });

    return {...updatedExpeditions, ...newUpdateExpeditions}
}

export const updateExpeditionShippingType = ( 
    expeditions: Record<string, NewExpedition>,
    expeditionsIdForChangeAddress: number[],
    type: ExpeditionShippingType
): Record<string, NewExpedition> => {

    let updatedExpeditions = {}
    expeditionsIdForChangeAddress.forEach((currentId, i) => {
        const updateExpedition = {[`${currentId}`]:  { ...expeditions[currentId], shippingTypeSelected: type}};
        updatedExpeditions = { ...updatedExpeditions, ...updateExpedition};
    });
    
    return {...expeditions, ...updatedExpeditions};
}

export const getSaveShippingMethodBody = (
    expeditions: Record<string, NewExpedition>,
): Array<CartShippingItxDto> => {
    
    const saveShippingMethodBody =  Object.values(expeditions)?.map((currentExpedition: NewExpedition)=>{
        if(currentExpedition.shippingTypeSelected === EXPEDITION_SHIPPING_TYPE.DROP2HOME ){
            return {
                sellerId: currentExpedition?.sellerdId ?? null,
                idShippingMethod: currentExpedition?.selectedDHShippingMethodId ?? null,
                idBuyerCollectAddress: currentExpedition?.homeAddressSelected?.id ?? null,
    
            }
        } else {
            return {
                sellerId: currentExpedition?.sellerdId ?? null,
                idShippingMethod: currentExpedition?.selectedDPShippingMethodId ?? null,
                idBuyerCollectAddress: currentExpedition?.dropPointAddressSelected?.pickUpPoint?.dropPointId ?? null,
    
            }
        }
    }) || []
    return [...saveShippingMethodBody]
}

export const expeditionInheritData = (
    expeditionReference: NewExpedition,
    expeditions: Record<string, NewExpedition>,
    idsForChange: Number[]
):Record<string, NewExpedition>  => {

    let updateExpeditions = {}
      
    idsForChange.forEach((currentId)=>{
      if(currentId !== expeditionReference.sellerdId){
        const updateExpedition = {[`${currentId}`] : {...expeditions[`${currentId}`], 
          ...{
            shippingTypeSelected: expeditionReference?.shippingTypeSelected,
            homeAddressSelected: expeditionReference?.homeAddressSelected, 
            dropPointAddressSelected: expeditionReference?.dropPointAddressSelected } }
      }
      updateExpeditions = {...updateExpeditions, ...updateExpedition}
    }
  })

  return {...expeditions, ...updateExpeditions}

}

export const firstExpeditionInheritData = (expeditions: Record<string, NewExpedition>, finalGroups: FinalGroups ) => {
    const internationalGroupReference =  finalGroups?.international?.length > 0 && finalGroups?.international[0];
    const nationalReference = finalGroups?.national?.length > 0 && finalGroups?.national[0];
    let updateIntExpeditions = {}
    let updateNatExpeditions = {}
  
    if(internationalGroupReference && internationalGroupReference?.sameOriginTypeGroupsIds?.length > 1){
      const internationalExpRef = expeditions[internationalGroupReference?.sellerId]
      updateIntExpeditions = expeditionInheritData(internationalExpRef, expeditions, internationalGroupReference.sameOriginTypeGroupsIds)
    }
    if(nationalReference && nationalReference?.sameOriginTypeGroupsIds?.length > 1){
      const nationalExpRef = expeditions[nationalReference?.sellerId]
      updateNatExpeditions = expeditionInheritData(nationalExpRef, expeditions, nationalReference.sameOriginTypeGroupsIds)
    }

    return { ...expeditions, ...updateIntExpeditions, ...updateNatExpeditions}
  }


export const getShippingMethodForType = (type: ExpeditionShippingType, shippingMethodsGroupData: ShippingMethodItxDto[]) => {
    return shippingMethodsGroupData?.find((shippingMethod) => shippingMethod.shippingMethodType?.name === type) ?? null;
}

const calculatePrices = (finalTotalWithoutShipping: number, newShippingTotalPrice: number, shippingPrice: PriceItxDto, totalPrice: PriceItxDto, taxesTotalPrice: number) => {
    const finalTotalPrice = {...totalPrice, value: finalTotalWithoutShipping + newShippingTotalPrice + taxesTotalPrice}
    let finalShippingPrice = {...shippingPrice, value: newShippingTotalPrice, exponent:shippingPrice?.exponent === 0 ? totalPrice?.exponent : shippingPrice?.exponent}
    return { finalTotalPrice: finalTotalPrice, finalShippingPrice: finalShippingPrice}

}

const calculateTotalShippingPrice = (newShippingTotalPrice: number, shippingPrice: PriceItxDto, totalPrice: PriceItxDto) => {
    const finalShippingPrice = {...shippingPrice, value: newShippingTotalPrice, exponent:shippingPrice?.exponent === 0 ? totalPrice?.exponent : shippingPrice?.exponent}
    return finalShippingPrice;
}

const getShippingPriceExpeditions = (expeditions: Record<string, NewExpedition>) => {
  const valuesForAdd = Object.values(expeditions)?.map(
    (currentExpedition: NewExpedition) => {
      if (
        currentExpedition?.shippingTypeSelected ===
        EXPEDITION_SHIPPING_TYPE.DROP2HOME
      ) {
        return currentExpedition?.selectedDHShippingMethodPrice?.value ?? 0;
      } else if (
        currentExpedition?.shippingTypeSelected ===
        EXPEDITION_SHIPPING_TYPE.DROPPOINT
      ) {
        return currentExpedition?.selectedDPShippingMethodPrice?.value ?? 0;
      } else {
        return 0;
      }
    },
  );
  return valuesForAdd.reduce((slot, currentValue) => {
    return slot + currentValue;
  }, 0);
};

export const getShippingStepPrices = (cart: ShoppingCartItxDto, expeditions: Record<string, NewExpedition>) => {
    const newShippingTotalPrice = getShippingPriceExpeditions(expeditions)
    return calculatePrices(cart?.finalTotalWithoutShipping?.value, newShippingTotalPrice, cart?.shippingTotal, cart?.finalTotal, cart?.totalTaxes?.value || 0)
}

export const getTotalShippingPrices = (cart: ShoppingCartItxDto, expeditions: Record<string, NewExpedition>) => {
    const newShippingTotalPrice = getShippingPriceExpeditions(expeditions)
    return calculateTotalShippingPrice(newShippingTotalPrice, cart?.shippingTotal, cart?.finalTotal)
}

export const getFinalGroups = (parcialGroups: GroupState[] | []): FinalGroups => {
    return {
        all: parcialGroups, 
        international: parcialGroups?.filter((group) => group.originType === "INTERNACIONAL" ) || [], 
        national: parcialGroups?.filter((group) => group.originType === "NACIONAL" ) || []
    }
}

